/** Whether server pack export should default on when LD is silent (local `npm start`). */
const reportPacksDevelopmentDefaultOn = (): boolean => process.env.NODE_ENV === 'development';

export default reportPacksDevelopmentDefaultOn;
